<template>
  <div>
    <main class="code d-flex align-items-md-center" style="position:relative; height :100%" v-cloak>
      <div class="w-100" v-if="currentQuestion">
        <div class="container">
          <div class="row" style="padding-bottom: 100px !important">
            <div class="col-12">
              <form>
                <p style="font-size:1.2em">
                  {{$t('Domanda')}}
                  <strong>{{numAnsweredQuestions}}</strong>
                  /{{numQuestions}}
                  <br>
                  <strong>{{nowSeconds}}</strong>
                  {{ $t('secondi per rispondere')}}
                </p>
                <h5
                  class="mb-5 mt-5 mt-md-0"
                  style="font-size: 30px; font-weight:normal"
                >{{currentQuestion.question}}</h5>
                <div class="text-center">
                  <img v-if="currentQuestion.image && imageReady" :src="`${currentQuestion.image}`" alt="" class="img-fluid customImage">
                </div>

                <div class="pl-3 pr-3 mt-3">
                  <div v-for="answer in currentQuestion.answers" v-bind:key="answer.id">
                    <button
                      type="button"
                      class="btn btn-outline-primary btn-lg btn-block"
                      name="answer"
                      style="font-size: 20px; font-weight:normal; white-space: normal; word-wrap: break-word"
                      @click="saveAnswer(answer.id)"
                    >{{answer.text}}</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div v-if="instantwinResponse" v-cloak>
      <transition name="modal">
        <div class="modal-mask" v-cloak>
          <div class="container">
            <div class="modal-wrapper" v-cloak>
              <message :message="instantwinResponse" @dismiss="dismissedResponseModal" v-cloak></message>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import Message from "./Campaign/MessageCenter/Message";
import _ from "lodash";
export default {
  name: "instantwin",
  data() {
    return {
      instantwinId: "",
      currentQuestion: "",
      status: "",
      maxSeconds: 0,
      numQuestions: 0,
      ticker: Date.now(),
      numAnsweredQuestions: 0,
      status: null,
      submittedAnswer: false,
      interval: null,
      instantwinResponse: false,
      outOfTime: false,
      fetchingAnswers: true,
      imageReady : true
    };
  },
  created() {
    this.initInstantwin();
  },
  methods: {
    async initInstantwin() {
      this.$store.commit("showSpinner");
      try {
        let response = await this.$http.get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/instantwins/" +
            this.$route.params.instantwinId
        );

        this.numQuestions = _.get(response, "data.data.questions_count");
        this.maxSeconds = _.get(response, "data.data.max_seconds_per_question");
        this.getNextQuestion();
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "waiting",
          title: "Something went wrong",
          text: "Please retry"
        });
      }

      this.$store.commit("hideSpinner");
    },
    async getNextQuestion() {
      this.startedQuestion = true;
      this.outOfTime = false;
      clearInterval(this.interval);
      this.$store.commit("showSpinner");
      this.imageReady = false;
      try {
        let response = await this.$http.get(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/instantwins/" +
            this.$route.params.instantwinId +
            "/question"
        );

        this.currentQuestion = _.get(response, "data.data");
        this.imageReady = true;
        this.numAnsweredQuestions++;

        if (this.currentQuestion) {
          this.start = Date.now();
          this.interval = setInterval(() => {
            this.ticker = Date.now();
          }, 100);
        } else {
          this.$router.push("/dashboard");
          this.$store.dispatch("getUserInfo");
          this.$store.dispatch("getUserTasks");
        }
      } catch {
        this.$store.commit("pushMessage", {
          type: "waiting",
          title: "Something went wrong",
          text: "Please retry"
        });
      }

      this.$store.commit("hideSpinner");
    },
    async saveAnswer(answerId) {
      this.$store.commit("showSpinner");
      this.submittedAnswer = true;
      clearInterval(this.interval);
      try {
        let response = await this.$http.post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/instantwins/" +
            this.$route.params.instantwinId +
            "/answer",
          {
            answer: answerId,
            seconds: this.maxSeconds - this.nowSeconds
          }
        );

        let typeOfAlert = "error";
        let message = "Risposta errata!";

        if (_.get(response, "data.data.correct", false)) {
          this.$store.dispatch("getUserInfo");

          typeOfAlert = "congratulation";
          message = "Risposta esatta!";
        }

        this.instantwinResponse = {
          type: typeOfAlert,
          title: message,
          text: "Punti " + _.get(response, "data.data.points", 0)
        };
      } catch (e) {
        this.$store.commit("pushMessage", {
          type: "waiting",
          title: "Something went wrong",
          text: "Please retry"
        });
      }

      this.$store.commit("hideSpinner");
    },
    async dismissedResponseModal() {
      if (this.submittedAnswer || this.outOfTime) {
        this.submittedAnswer = false;
        this.instantwinResponse = null;
        this.outOfTime = false;
        this.getNextQuestion();
      }
    }
  },
  computed: {
    nowSeconds() {
      let now = this.moment(this.ticker).unix();
      let start = this.start ? this.moment(this.start).unix() : now;
      let max = this.maxSeconds ? this.maxSeconds : 0;

      let pt = max - (now - start);
      pt = pt > 0 ? pt : 0;
      if (this.currentQuestion && this.startedQuestion && pt === 0) {
        this.outOfTime = true;
        this.startedQuestion = false;
        clearInterval(this.interval);
        this.instantwinResponse = {
          type: "error",
          title: "Out of time!"
        };
      }

      return pt;
    }
  },
  watch: {
    ticker: {
      handler: function(val) {},
      deep: true
    }
  },
  components: {
    Message
  }
};
</script>
<style scoped>

@media(hover:none) {
  button:hover {
    background-color: transparent !important;
    color: #0058A2 !important
  }
}

.modal-content {
  position: relative;
  padding-top: 51px;
}
.modal-header,
.modal-footer {
  border: 0;
}
.modal-header {
  padding-bottom: 0;
}
.modal-body {
  padding-top: 0;
}
.modal-icon {
  position: absolute;
  top: 0;
  left: 50%;
  height: auto;
  width: 102px;
  margin-left: -51px;
  margin-top: -51px;
  padding: 4px;
  overflow: hidden;
  border-radius: 50%;
}
.modal-icon > .icon {
  fill: currentColor;
  border-radius: 50%;
  overflow: hidden;
  height: 94px;
  width: 94px;
  line-height: 94px;
  text-align: center;
}
.modal-icon > .icon > div {
  fill: currentColor;
  height: 64px;
  display: block;
  margin: 15px auto;
  width: 64px;
}
.modal-icon > .icon > div > svg {
  fill: currentColor;
  height: 64px;
  display: block;
  margin: 0 auto;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  transition: opacity 0.3s ease;
}
.modal-mask .container {
  height: 100%;
  position: relative;
  display: table;
}

.modal-mask .container .close {
  position: absolute;
  top: 22px;
  right: 30px;
  opacity: 1;
  font-size: 66px;
  font-weight: lighter;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.customImage{
  width : 40%;
}
@media(hover:none) {
  button:hover {
    background-color: transparent !important;
    color: rgb(0, 0, 0) !important
  }
}


</style>